import { handleFilters } from "util/filters";
import { initGoogleMapsAsync } from "util/google-maps";
import Page from "webPage/Page";

Page.register([
    '/apprenticeships/apprentices/current-vacancies/([0-9a-f]+)/',
], ([]) => {
    handleVacancyMap();
});

function handleVacancyMap() {
    const $container = $(".js-map-container");

    if ($container.length === 0) {
        return;
    }

    initGoogleMapsAsync(() => {
        const geocoder = new google.maps.Geocoder();

        console.log(geocoder);
        geocoder.geocode({
            address: $container.attr("data-location"),
        }, (results, status) => {
            console.log("Geocoding results", {
                results,
                status,
            });
            if (status !== google.maps.GeocoderStatus.OK) {
                console.error("Couldn't geocode address", {
                    status,
                    results,
                });
                $container.remove();
                return;
            }

            const map = new google.maps.Map($container[0], {
                center: results[0].geometry.location,
                zoom: 8,
            });

            const marker = new google.maps.Marker({
                map,
                position: results[0].geometry.location,
            });
        });
    });
}
